import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDarkMode } from "@rbnd/react-dark-mode";
import LoaderNd, { COMPACT_MIN_HEIGHT } from "../nouveauDesign/etats/LoaderNd";
import { LOADER_DELAY_MS } from "../../helper/useDelayedLoader";

// 📍 Place de l'écran de chargement (tour 40) : « ecran » (plein écran, comme avant) ou « espace »
// (pages des espaces prof et élève, nouveau design : dans le contenu, sous l'en-tête, la cloche et
// les onglets, qui restent affichés ; avant, le livre couvrait toute la page). Posée par
// routes/studentRoutes.js, routes/teacherRoutes.js et EspaceChargement.
export const LoaderPlaceContext = createContext("ecran");

// ⏳ immediate : l'appelant a déjà attendu 300 ms (helper/useDelayedLoader.js : App.js, tableau de
// bord). Sinon (pages, chargement d'une page), l'écran n'apparaît qu'au-delà de 300 ms : un
// chargement rapide ne le montre jamais (tour 34).
function Loader({ immediate = false }) {
  const { mode } = useDarkMode();
  const inSpace = useContext(LoaderPlaceContext) === "espace";
  const [visible, setVisible] = useState(immediate);
  useEffect(() => {
    if (visible) return undefined;
    const id = setTimeout(() => setVisible(true), LOADER_DELAY_MS);
    return () => clearTimeout(id);
  }, [visible]);

  // Le Loader prend instantanément la bonne couleur de fond
  const bgColor = mode === "dark" ? "#1e1e1e" : "#ffffff";
  if (!visible) return <div data-testid="loader-wait" style={inSpace ? { minHeight: COMPACT_MIN_HEIGHT, width: '100%', background: 'var(--nd-fond-page)' } : { backgroundColor: bgColor, minHeight: '100vh', width: '100%' }} />;

  // 📚 Le livre ouvert d'Etats.html (tour 34)
  return <LoaderNd compact={inSpace} />;
}

export default Loader;
